import { gql } from "@/generated"

export const getOrganizationQuery = gql(`
  query Organization($memberInviteToken: String){
    organization(memberInviteToken: $memberInviteToken){
      id
      name
    }
  }
`)
